import React, { Component } from "react";
import Icon from "../../global/Icon/Icon";
import fetchAPI from "../../../utils/fetchAPI";
import { getVarConfig } from "../../../utils/environment";
import { getUser } from "../../../utils/sessionInfo";
import { trigger } from "../../../utils/events";
import { cleanCookiesAndReload } from "../../../utils/cookiesUtils";
import { Dialog } from "@mui/material";
import { LogoutOutlined } from "@mui/icons-material";

import "./MazTuInfoBeesHeader.scss";

export default class MazTuInfoBeesHeader extends Component {

  state = {
    confirmOpen: false,
  };

  handleLogoutClick = () => {
    this.setState({ confirmOpen: true });
  };

  handleLogoutConfirm = () => {
    this.setState({ confirmOpen: false });
    localStorage.clear();
    this.props.setLoaderOpen(true);
    this.props.setPath("/cerrar");
    this.props.setLoaderOpen(false);
    cleanCookiesAndReload();
  };

  handleLogoutCancel = () => {
    this.setState({ confirmOpen: false });
  };

  handleBackNavigation = () => {
    if (
      this.props.path === "/desafios" ||
      this.props.path === "/historial" ||
      this.props.path === "/resultados" ||
      this.props.path === "/registro" ||
      this.props.path === "/facturacion" ||
      this.props.path === "/cobertura" ||
      this.props.path === "/registro/exito" ||
      this.props.path === "/contrato" ||
      this.props.path === "/programa-mercado"
    ) {
      if(this.props.path === "/registro" || this.props.path === "/registro/exito") {
        this.props.setPath("/");
      } else {
        if(this.props.path === "/resultados") {
          this.setResultadosLastSeen();
        } else {
          if(this.props.path === "/programa-mercado") {
            trigger("click-back-navigation-programa-mercado");
          } else {
            this.props.setPath("/dashboard");
          }
        }
      }
    } else if (this.props.needBackButton){
      console.log("Path previo: " + this.props.previousPath);
    }
  }

  setResultadosLastSeen = () => {
    this.props.setLoaderOpen(true);
    let date = new Date();
    const [month, day, year] = [date.getMonth(), date.getDate(), date.getFullYear()];
    const dateSeen = (month + 1) + "/" + day + "/" + year;
    let urlService = getVarConfig({ key: "REACT_APP_SERVICES_POST_RESULT_SEEN" });
    fetchAPI({
      service: urlService,
      protocol: "POST",
      params: {
        resultsSeen: dateSeen,
      },
      callbackThen: (response) => {
        this.props.setLoaderOpen(false);
        this.props.setPath("/dashboard");
      },
      callbackError: (status) => {
        this.props.setLoaderOpen(false);
        this.props.setPath("/dashboard");
      },
    });
  }

  render() {

    const userInfo = getUser();
    let name, ID;
    if(userInfo !== null) {
      name = typeof userInfo.name !== "undefined" ? userInfo.name : "";
      ID = typeof userInfo.ID !== "undefined" ? (this.props.user.isFinanceUser ? (userInfo.ID.charAt(0) == 1 ? "Matriz - " : `Sucursal ${userInfo.sucursal} - `):"") + userInfo.ID : "";
    } else {
      name = "";
      ID = "";
    }


    return (
      <>
      <div className="maz-tu-info-bees-header">
        <div className="container-fluid px-0 flex-wrap">
          <div className="container d-flex justify-content-between align-items-center flex-wrap px-0">
        {this.props.path === "/desafios" ||
        this.props.path === "/registro" ||
        this.props.path === "/facturacion" ||
        this.props.path === "/cobertura" ||
        this.props.path === "/historial" ||
        this.props.path === "/resultados" ||
        this.props.path === "/registro/exito" ||
        this.props.path === "/contrato" ||
        this.props.path === "/programa-mercado" ||
        this.props.needBackButton ? (
          <div
            className="maz-tu-info-bees-header__back-navigation"
            onClick={this.props.needBackButton? this.props.backButtonAction : this.handleBackNavigation}
          >
            <Icon icon={"back-navigation"} size="30" />
            <span>Atrás</span>
          </div>
          ) : ("")}

        <div className="maz-tu-info-bees-header__logo ms-3"></div>

          <div className={`maz-tu-info-bees-header__user-info ${this.props.user.isFinanceUser ? "col-12 col-lg-auto": ""}`}>
            <div className="maz-tu-info-bees-header__user-data">
              <div className="maz-tu-info-bees-header__user-name">
                <span><b>{name}</b></span>
              </div>
              <div className="maz-tu-info-bees-header__user-id">
                {ID}
              </div>
            </div>
            {userInfo !== null && name && this.props.path !== "/" && this.props.path !== "/cerrar" && (
              <button
                className="maz-tu-info-bees-header__logout-btn"
                onClick={this.handleLogoutClick}
                title="Cerrar sesión"
              >
                <LogoutOutlined className="maz-tu-info-bees-header__logout-icon" />
                <span>Cerrar sesión</span>
              </button>
            )}
          </div>
          </div>
        </div>
      </div>

      <Dialog
        open={this.state.confirmOpen}
        onClose={this.handleLogoutCancel}
        PaperProps={{ className: "logout-dialog" }}
      >
        <div className="logout-dialog__content">
          <div className="logout-dialog__icon-wrap">
            <LogoutOutlined className="logout-dialog__icon" />
          </div>
          <p className="logout-dialog__message">
            Estás a punto de cerrar sesión.<br />¿Es esto lo que deseas hacer?
          </p>
          <div className="logout-dialog__actions">
            <button
              className="logout-dialog__btn logout-dialog__btn--cancel"
              onClick={this.handleLogoutCancel}
            >
              Cancelar
            </button>
            <button
              className="logout-dialog__btn logout-dialog__btn--confirm"
              onClick={this.handleLogoutConfirm}
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </Dialog>
      </>
    );
  }
}
